import { BuilderFormValues } from '../containers';

type ValidationErrors = Record<string, string[] | undefined>;

export const validateBuilder = async (
  values: BuilderFormValues,
): Promise<ValidationErrors> => {
  const errors: ValidationErrors = {};
  if (!values.name) {
    errors.name = ['The name is required'];
  }
  if (!values.code) {
    errors.code = ['The Code is required'];
  }
  return errors;
};
